import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import AmColumnAndLineChart from '../../../../commonComponents/charts/AmColumnAndLineChart';

function PvEvolution(props) {
  const { t, data } = props;

  return (
    <>
      <div>
        <div className="header-container">
          <h5>{t('report.mivitana.pvEvolution')}</h5>
        </div>
        <AmColumnAndLineChart
          containerClass="career-leg-chart"
          chartId="test-yann"
          options={{
            category: 'weekLabel',
            yLabel: '',
            columnValueKey: 'leftLeg',
            column2ValueKey: 'rightLeg',
            columnSeriesName: t('report.mivitana.leftPV'),
            column2SeriesName: t('report.mivitana.rightPV'),
            colorRect2: '#EC6F2D',
            colorRect: '#F5D509',
            closerColumns: false,
            isStacked: true,
            showLegend: true,
          }}
          type="layeredColumns"
          stats={data}
        />
      </div>
    </>
  );
}

PvEvolution.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      leftLeg: PropTypes.number.isRequired,
      rightLeg: PropTypes.number.isRequired,
      weekLabel: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default translate(PvEvolution);
